import _set from 'lodash/set';
import { BulletProps } from '@src/slide/application/service/bullets-and-numbering-dialog-manager/core/interface';
import { BuiltInBulletCharacterConfigs, CharacterTypes, NumberingCharacterTypes } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/character-type';

const SCALE = 0.9;
export function getScaleSize({ fontSize = 36 } = {}, buSzPct) {
    return fontSize / 20 * SCALE * (buSzPct ? buSzPct : 1);
}
/**
 * 根据项目符号类型获取对应的配置
 */
export function getCharacterConfigByType(type: string) {
    if (type === CharacterTypes.ITEMSYMBOL_NONE) {
        return null;
    }
    if (NumberingCharacterTypes.includes(type)) {
        return {
            buAutoNum: {
                type,
            },
        };
    }
    const characterConfig = BuiltInBulletCharacterConfigs.find(item => item.type === type);
    if (!characterConfig) {
        return null;
    }
    const { charset, typeface, character_bullet_char } = characterConfig;
    return  {
        buFont: {
            charset,
            typeface,
        },
        character_bullet_char,
    };
}

/**
 * 根据原始项目符号数据和修改项生成新的项目符号
 * @param originCharacter
 * @param param1
 * @returns
 */
export function reduceCharacterData(
    originCharacter,
    { type, size, color, customText, customImage, startNumber }: BulletProps,
) {
    const newCharacter = reduceCharacterType(originCharacter, type, customText, customImage);
    // 设置大小
    if (typeof size === 'number') {
        // 如果设置了大小，就清除大小跟随属性
        delete newCharacter.buSzTx;
        newCharacter.buSzPct = size;
    }
    // 设置颜色
    if (color !== undefined) {
        // 如果设置了颜色，就清除颜色跟随属性
        delete newCharacter.buClrTx;
        if (color === null) {
            delete newCharacter.buClr;
        } else {
            newCharacter.buClr = {
                color,
            };
        }
    }
    // 设置起始编号
    if (startNumber) {
        if (newCharacter.buAutoNum) {
            newCharacter.buAutoNum.startAt = startNumber;
        }
    }
    return newCharacter;
}

/**
 * 处理项目符号类型相关逻辑
 * 如果没传入类型，有以下情况
 * 1. 选中多个段落，存在各种项目符号，有的没有项目符号
 * 2. 选中的段落本身就没有项目符号
 * 3. 设置了自定义文字或图片项目符号
 * 所以最终的类型需要由合并后的数据确定
 * @param originCharacter
 * @param type
 * @param customText
 * @param customImage
 * @returns
 */
function reduceCharacterType(originCharacter, type, customText, customImage) {
    let newCharacter = {
        ...originCharacter,
    };
    if (type === CharacterTypes.ITEMSYMBOL_NONE) {
        // 如果是继承来的项目符号，重新设置为空的话，需要设置 buNone = 1 才能保证项目符号不显示
        newCharacter.buNone = 1;
    } else {
        delete newCharacter.buNone;
    }
    // 获取新类型的配置
    const newTypeConfig = getCharacterConfigByType(type);
    // 设置了新的类型或者要删除项目符号类型，都需要清除掉互斥的数据
    if (newTypeConfig || type === CharacterTypes.ITEMSYMBOL_NONE || customText || customImage) {
        // 生成了新的类型，需要清除掉互斥的旧的类型相关的数据
        delete newCharacter.buAutoNum;
        delete newCharacter.buBlip;
        delete newCharacter.buFont;
        // 去除项目符号字体跟随属性
        delete newCharacter.buFontTx;
        delete newCharacter.character_bullet_char;
    }
    // 设置自定义文字
    if (customText) {
        newCharacter.character_bullet_char = customText;
    }
    // 设置自定义图片
    if (customImage) {
        _set(newCharacter, 'buBlip.blip.src', customImage);
    }
    newCharacter = {
        ...newCharacter,
        ...newTypeConfig,
    };
    // 根据合并后的完整数据确定是否有项目符号
    newCharacter.character = hasBullet(newCharacter);
    return newCharacter;
}

/**
 * 判断是否有项目符号
 * @param characterProps
 * @returns
 */
export function hasBullet(characterProps) {
    const { buNone, character_bullet_char: bulletChar, buAutoNum, buBlip } = characterProps || {};
    if (buNone === 1) {
        return false;
    }
    return bulletChar || buAutoNum || buBlip;
}
